import React from 'react';
import { GOLD } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';
import GoldBtn from './ui/GoldBtn';

const Banner: React.FC = () => (
  <div style={{ backgroundImage:`url(${IMGS.banner})`, backgroundSize:'cover', backgroundPosition:'center', backgroundAttachment:'fixed', padding:'90px 8vw', position:'relative', textAlign:'center' }}>
    <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.74)' }}/>
    <div style={{ position:'relative', zIndex:1 }}>
      <SecLabel text="SPECIAL OCCASION"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,4.2vw,56px)', fontWeight:300, color:'#fff', marginTop:6 }}>
        Let Us Make Your Event<br/><em style={{ color:GOLD }}>Unforgettable</em>
      </h2>
      <p style={{ color:'rgba(255,255,255,0.65)', fontFamily:'Montserrat', fontSize:12, letterSpacing:1, marginTop:16, maxWidth:460, margin:'16px auto 0' }}>
      We Are Gowjee, We Don't Just Organise Events We Create Memories. Turn Your Vision Into Reality With Us.
      </p>
      <div style={{ marginTop:32 }}><GoldBtn href="#contact" outline={false}>Get in Touch</GoldBtn></div>
    </div>
  </div>
);

export default Banner;